export const EDIT_SESSION_POPUP_LABELS = {
	EDIT_SESSION_TITLE: 'Edit Session',
	SESSION_NAME: 'Session name',
	PLATFORM_LABELS_TITLE: 'Platform labels',
	INSTRUCTIONS:
		"Label reports requiring documentation in accordance with the organization's accessibility standards.",
	DISMISS_MESSAGE: 'Changes you make will be saved on the Platform only',
	DISMISS_BUTTON: 'Dismiss',
	CANCEL_BUTTON: 'Cancel',
	SAVE_BUTTON: 'Save',
	UPDATE_SUCCESS: 'Session updated successfully',
	UPDATE_FAILURE: 'Failed to update session',
	getSelectLabelPlaceholder: (labelName: string): string => `Select a ${labelName}`
} as const;
